<template>
  <modal class="fastWestStoredModel" :isShow="isShow" @keyup.esc="hide">
    <div class="header">西软XMS储值支付<span class="close" @click="hide()">×</span></div>
        <tabs class="modal-body" >
            <div ref="CardMoney">
            <div class="filter-nav">
                <div class="queryWhole">
                    <div class="query">查询模式:</div>
                    <div class="querymodel">
                        <label class="checkbox"><input type="radio" name="_fa_radio" @click="radio(0)" :checked="true" />
                        <i class="iconfont icon-a-danxuanweixuanzhong"></i>卡号</label>
                    </div>
                    <div class="querymodel">
                        <label class="checkbox"><input type="radio" name="_fa_radio" @click="radio(1)" />
                        <i class="iconfont icon-a-danxuanweixuanzhong"></i>手机号</label>
                    </div>
                    <div class="querymodel">
                        <label class="checkbox"><input type="radio" name="_fa_radio" @click="radio(2)"/>
                        <i class="iconfont icon-a-danxuanweixuanzhong"></i>姓名</label>
                    </div>
                    <div class="querymodel">
                        <label class="checkbox"><input type="radio" name="_fa_radio" @click="radio(3)"/>
                        <i class="iconfont icon-a-danxuanweixuanzhong"></i>身份证</label>
                    </div>
                    <div class="querymodel">
                        <label class="checkbox"><input type="radio" name="_fa_radio" @click="radio(4)"/>
                        <i class="iconfont icon-a-danxuanweixuanzhong"></i>邮箱</label>
                    </div>
                </div>
            </div>
             <div></div>
            <div class="clearfix" >
                <div class="left-box">
                    <tab-pane>
                        <div class="tr-li">
                            请输入查询码：
                            <div class="from-input" style="width:325px" >
                                <input type="text" v-mode-en="queryMode!=2" ref="input" @focus="(e)=>e.target.select()" 
                                    class="key-focus" data-model='idCode' 
                                    v-model="idCode" isBarcode 
                                    @barcode="onMemberInfo(true)" 
                                    @keydown.enter="onMemberInfo()" />
                                <i class="iconfont icon-sousuo" @click="onMemberInfo()"></i>
                            </div>
                            <button class="btn" v-if="queryMode==0" @click="readCard()">读卡</button>
                        </div>
                        <div class="table-box">
                            <div class="tr-li">
                                <div class="lable-txt" style="width:220px;">会员卡号：<span style="color: #000;font-size: 14px;">{{meberInfo?.cardno}}</span></div>
                                <div class="lable-txt" style="width:180px;">会员等级：<span style="color: #000;font-size: 14px;">{{meberInfo?.cardtype}}</span></div>
                                <div class="lable-txt" style="width:145px;">姓名：<span style="color: #000;font-size: 14px;">{{meberInfo?.guest_name}}</span></div>
                            </div>
                            <div class="tr-li">
                                <div class="lable-txt" style="width:220px;">
                                    <span style="letter-spacing:0.5em;">手机</span>号:
                                    <span style="color: #000;font-size: 14px;">{{meberInfo?.mobile}}</span>
                                </div>
                                <div class="lable-txt" style="width:180px;">
                                    性<span style="padding-left:25px;">别</span>：
                                    <span style="color: #000;font-size: 14px;" v-if="meberInfo?.Gender>-1">{{meberInfo?.Gender==0?'男':'女'}}</span>
                                </div>
                                <div class="lable-txt" style="width:160px;">余额：
                                    <span style="color: #000;font-size: 14px;" v-if="meberInfo">{{Number(meberInfo?.arbal).toFixed(2)}}</span>
                                </div>
                                
                            </div>
                            <div class="tr-li">
                                <div class="lable-txt" style="width:220px;" >
                                    积分余额：
                                    <span style="color: #000;font-size: 14px;" v-if="meberInfo">{{meberInfo?.credit}}</span>
                                </div>
                                <div class="lable-txt" style="width:180px;">
                                    积分可抵用金额：
                                    <span style="color: #000;font-size: 14px;" v-if="meberInfo">{{Number(meberInfo?.ReditMoney).toFixed(2)}}</span>
                                </div>
                                
                            </div>
                        </div>
                    </tab-pane> 
                </div>
                <div class="right-box">
                    <div class="keyboard">
                        <div class="key-li"><span data-value="7">7</span><span data-value="8">8</span><span
                                data-value="9">9</span></div>
                        <div class="key-li"><span data-value="4">4</span><span data-value="5">5</span><span
                                data-value="6">6</span></div>
                        <div class="key-li"><span data-value="1">1</span><span data-value="2">2</span><span
                                data-value="3">3</span></div>
                        <div class="key-li"><span data-value=".">.</span><span data-value="0">0</span><span
                                data-value="back"><i class="iconfont icon-zuojiantou"></i></span></div>
                    </div>
                </div>
            </div>
            <div class="money-info">
                <!-- -->
                <div class="lable-txt">待支付金额：
                    <b class="noney red" v-if="unPaidMoney>0">{{(Conversion((unPaidMoney.toFixed(2)-Number(PointPayCouponMoney)).toFixed(2)))}}</b> 
                    <b class="noney red" v-if="unPaidMoney<=0">0</b>
                </div>
                <div class="lable-txt" v-if="is_CardPayShow">储值支付：
                    <input type="text" class="key-focus" style="color:red;" ref="couponsPayinput" data-model='couponsPay' v-model="couponsPay" @click="onCouponPayClick()" />
                </div>
                <div class="lable-txt" v-if="is_CardPayShow">积分支付：
                    <input type="text" class="key-focus"  style="color:red;" ref="PointPayinput"  data-model='PointPayMoney' :placeholder="PointPay_Scale"  v-model="PointPayMoney" @click="onIntegralClick()"/>
                </div>
            </div>
            </div>
        </tabs>
        <div class="footer-box">
            <div style="position:absolute;width:91%;height:10%;" v-if="PayResultCode==1" ></div>
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-border" @click="select()" v-throttle>重新查询支付结果</button>
            <button class="btn btn-confirm" @click="confirm()" v-throttle>确认</button>
        </div>
     <!--会员卡信息-->
    <modal-load :isShow="cardMemberShow">
        <card-member-Model :isShow="cardMemberShow" v-on:closeModel="cardMemberShow=false" :data="cardMemberList" @confirm="selectCardInfo" ></card-member-Model>
    </modal-load>
    <modal-load :isShow="cardCodeShow">
        <card-code-model :isShow="cardCodeShow" v-on:closeModel="cardCodeShow=false" @cardCodeConfirm="cardCodeConfirm"></card-code-model>
    </modal-load>
    <!--密码验证-->
    <modal-load :isShow="passwordShow">
        <password-confirm-model :isShow="passwordShow" v-on:closeModel="passwordShow=false" @passwordConfirm="passwordConfirm"></password-confirm-model>
    </modal-load>
    <!--会员刷卡-->
    <modal-load :isShow="swipeShow">
        <swipe-card-model :isShow="swipeShow" v-on:closeModel="swipeShow=false" @swipeConfirm="swipeConfirm"></swipe-card-model>
    </modal-load>
  </modal>
</template>


<script>
import cardCodeModel from '../../diningDetail/model/cardCodeModel.vue'
import passwordConfirmModel from '../../diningDetail/model/passwordConfirmModel.vue'
import swipeCardModel from '../../diningDetail/model/swipeCardModel.vue'
import cardMemberModel from '../../model/cardMemberModel/cardMemberModel.vue'
import {initKeyBoard,NumberConversion,newGuid,submitting} from '/src/common' 
/**会员支付 */
export default {
    name:"westStoredModel",
    components:{
        cardMemberModel,
        cardCodeModel,
        passwordConfirmModel,
        swipeCardModel,
    },
    props:{
        isShow:Boolean,
        orderInfo:Object,
        choicePayType:Object,
        payType:Object,
        snackPaidMoney:Number,
        orderMenuList:Object,
        MantissaMoney:Number,
        headingInfo:Object,
        Channellike:String,
        RoomAutoID:String,
        DeskName:String,
        paymentHistory:Object,
        EatAutoIDs:String,
        Timestamps:String,
        totalMoney:Number,
        discountMoneuy:Number
    },
    data(){
        return {
            cardMemberShow:false,
            is_CardPayShow:true,
            cardCodeShow:false,
            passwordShow:false,
            swipeShow:false,
            is_AllowMixUsing:false, //是否有不可混用券
            is_AllowMixUsingCoupon_Name:'', //不可混用券
            idCode:'',//身份码
            payCode:'',//付款码
            meberInfo:'', //会员信息
            cashCoupon:'', //代金券
            commodityVoucher:'',//商品券
            couponsPay:'', //储值支付金额
            PointPay:'', //积分支付积分
            PointPayMoney:'',//积分支付金额
            PointPayCouponMoney:'',
            unPaidMoney:0, //待付金额
            memberorderInfo:'',  //临时订单数据
            scanPayCode:'',
            /**联台结账订单新时间戳 */
            UnionOrders:'',
            /**是否触发过订单提交接口*/
            PayResultCode:0,
            /**保存订单支付返回记录 */
            payPreviewData:'',
            /**错误提示 */
            errorTitle:'',
            cardMemberList:[], //会员卡信息
            verifyCode:'', //验证码
            PointChecked:false, //是否参与线上积分支付
            /**权限验证临时保存ID和操作员 */
            tempUserId:'',
            tempOperatorName:'',
            isCardPayPwd:'',
            queryMode:-1,//查询模式 5储值查询 0散客查询,1团队查询,2应收账查询
            queryType:-1,//查询类型
            queryCode:'',//查询码
            PointPay_Scale:'', //积分比例
        }
    },
    mounted(){
       this.$nextTick(()=> {
           initKeyBoard.call(this,this.$refs.CardMoney);
           initKeyBoard.call(this,this.$refs.zf);
           this.openimp()
        })
    },
    watch: {
        orderInfo:{
            immediate:true,
            handler(vla){
                this.EmptyDatas();

                this.couponsPay=0
                this.memberorderInfo = JSON.parse(JSON.stringify(this.orderMenuList))
                if(this.memberorderInfo){
                   
                    for(let i=0; i<this.memberorderInfo.length; i++){
                        Object.assign(this.memberorderInfo[i],{isCoupon:false,CouponNumber:0})
                        if(this.memberorderInfo[i].Is_Gift==true || (this.memberorderInfo[i].Eat_Number==0 && this.memberorderInfo[i].Refund_Number>0)){
                            this.memberorderInfo.splice(i,1)
                            i--
                        }
                    }
                }
                this.unPaidMoney = this.snackPaidMoney;
                if(this.memberorderInfo.Member_CardNo){
                    if(this.idCode==''){
                        this.idCode = this.memberorderInfo.Member_CardNo
                    }
                }
                this.cardInfoShow()
                this.PointPayCouponMoneyInfo(0)
                this.radio(0)
            }
        },
        //用于观察数据变动。对应一个对象,键是观察表达式,值是对应回调。子组件中 需要结合watch监听
        isShow() { 
            if(this.isShow==true){
                this.openimp()
            }
        },
        couponsPay(){
            if(this.couponsPay<0){
               this.couponsPay=0
            }
            this.PointPayCouponMoneyInfo(1)
        },
        PointPayMoney(){
            if(this.PointPayMoney<0){
               this.PointPayMoney=0
            }else{
                if(Number(this.PointPayMoney)>this.meberInfo.ReditMoney){
                    this.$message.warning('您的可用积分余额为:'+this.meberInfo.ReditMoney+'');
                    this.PointPayMoney=this.meberInfo.ReditMoney
                    return
                }
            }
            this.PointPayCouponMoneyInfo(2)
        },
    },
    methods:{
        openimp(){
            this.EmptyDatas();
            this.idCode='',this.errorTitle=''
            this.initializaTion()
            this.memberorderInfo = JSON.parse(JSON.stringify(this.orderMenuList))
                if(this.memberorderInfo){
                    for(let i=0; i<this.memberorderInfo.length; i++){
                        Object.assign(this.memberorderInfo[i],{isCoupon:false,CouponNumber:0})
                        if(this.memberorderInfo[i].Is_Gift==true || (this.memberorderInfo[i].Eat_Number==0 && this.memberorderInfo[i].Refund_Number>0)){
                            this.memberorderInfo.splice(i,1)
                            i--
                        }
                    }
                }
            this.unPaidMoney = this.snackPaidMoney
            if(this.memberorderInfo.Member_CardNo){
                this.idCode = this.memberorderInfo.Member_CardNo
                this.onMemberInfo()
            }
            this.PointPayCouponMoneyInfo(0)
            this.radio(0)
        },
        radio(type){
            this.queryMode=type
            this.EmptyDatas()
        },
        /**默认input焦点 */
        EmptyDatas(){
            setTimeout(() => {
                this.$refs.input?.focus();
            },100);
        },
        blurRechargeMoney(){
            if(this.unPaidMoney.toFixed(2)<0){
                this.unPaidMoney =0
            }
        },
        /**实体卡读卡 */
        readCard(){
            this.$webBrowser.redCardM1({type:"西软XMS",password:null}).then((d)=>{
                if(d){
                    if(d.state==0){
                        this.idCode = d.data.cardID.substr(8);
                        this.idCode = this.idCode.trim();
                        this.onMemberInfo()
                    }else{
                        this.$message.error('卡信息读取失败：'+d.message);
                    }
                }
            })
        },
        /**查询支付结果 */
        select(){
            if(this.EatAutoIDs!=''){
                this.eatAutoID = this.EatAutoIDs
                this.ordertimestamps = this.Timestamps
            }
            if(this.eatAutoID==''){
                this.$message.warning('没有需要查询的支付结果');
                return
            }
            this.userInfo=this.$auth.getUserInfo(); //获取用户id
            const loading = this.$loading({
                text: "查询支付结果中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.1)",
            });
            this.userInfo=this.$auth.getUserInfo(); //获取用户id
            let param={
                User_ID:this.userInfo?.User_ID,  //用户id
                Eat_AutoID:this.eatAutoID, //结账单ID
                Operator_Name:this.userInfo?.Login_Name, //操作员
                Operate_EquipmentID:this.userInfo?.Site_Serial, //设备id
                Pos_StationName:this.userInfo?.Site_Name, //站点名称
                Timestamps:this.ordertimestamps.toString(), //账单时间戳
            }
            if(this.ordertimestamps!=''){
                param.Timestamps = this.ordertimestamps.toString();
            }
            this.$httpAES.post("Bestech.CloudPos.RequeryThePaymentResult",param).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode!=0){
                    this.errorTitle = d.ResponseHeader.ResultDesc
                    this.ispaySuccess=1
                    if(d.ResponseHeader.ResultCode==4003){
                        this.$message.error(d.ResponseHeader.ResultDesc);
                        this.ispaySuccess=0
                        this.payCode=''
                        this.ordertimestamps = d.ResponseBody?.Timestamps.toString();
                    }
                    return;
                }else{
                    let ResultDesc = '未查询到订单的支付结果'
                    if(d.ResponseHeader.ResultDesc==''){
                        d.ResponseHeader.ResultDesc = ResultDesc
                    }
                    this.$alert(d.ResponseHeader.ResultDesc, '提示', {
                        confirmButtonText: '确定',
                        callback: () => {
                            this.ordertimestamps = d.ResponseBody.Timestamps;
                            this.ispaySuccess=0;
                            this.$emit("ThePaymentResultClic",d,this.payCode)
                        }
                    });
                    return;
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
        /**获取会员信息 
         * @param isBarcode 是否是扫码传入的
        */
        onMemberInfo(isBarcode){
            if(!this.idCode){
                this.$message.error('查询码不能为空');
                return
            }
            this.idCode =this.idCode.replace(/[;,；,=,＝,?,？]/g,"");
            this.userInfo=this.$auth.getUserInfo(); //获取用户id
            this.initializaTion()
            let param={
                Body_ID:newGuid(),
                User_ID:this.userInfo?.User_ID,  //用户id
                Query_Mode:5,//储值查询
                Member_Type:this.queryMode,
                Query_Code:this.idCode,
            }
            const loading = this.$loading({
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.1)",
            });
            this.$httpAES.post("Bestech.CloudPos.GetXrXMSCorpInfo",param).then((data)=>{
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc);
                    this.idCode=''
                }else{
                    if(data.ResponseBody?.length==0){
                        this.$message.warning('查询不到对应的会员信息!');
                        this.idCode=''
                        return
                    }else{
                        if(data.ResponseBody?.length>1){
                            this.cardMemberList = data.ResponseBody;
                            this.cardMemberList.forEach(card=>{
                                Object.assign(card,{
                                    Bestech_Card_AutoID:card.sno,
                                    Card_No:card.cardno,
                                    Bestech_Card_KindName:card.cardtype,
                                    Card_Money:card.arbal,
                                    Card_PilePoint:card.credit,
                                    MemberName:card.guest_name
                                })
                            })
                            this.cardMemberShow=true;
                        }else{
                            this.isread=true
                            this.meberInfo=data.ResponseBody[0];
                            this.meberInfo = Object.assign(this.meberInfo,{Card_No:this.meberInfo.cardno})
                            this.cardInfoShow()
                            this.idCode = this.meberInfo.cardno;
                        }
                    }
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
        hide(){
            if(this.PayResultCode==1){
                this.$message.warning('有待支付的订单,无法调整');
                return
            }
            this.$emit("close")
        },
        /**确定付款 */
        confirm:submitting(function(event){
            if(!this.meberInfo){
                this.$message.warning('请先读取会员卡');
                return
            }
            //储值和积分不能同时使用
            if(Number(this.couponsPay)>0 && Number(this.PointPayMoney)>0){
                this.$message.error('储值和积分不能同时使用');
                return
            }
            if(Number(this.PointPayMoney)>0){
                if(Number(this.meberInfo.ReditMoney)<Number(this.PointPayMoney)){
                    this.$message.error('您的积分可用余额不足');
                    return
                }
                if(Number(this.PointPayMoney)>Number(this.unPaidMoney.toFixed(2))){
                    this.$message.error('积分可兑换金额超过待支付金额');
                    return
                }
            }
            if(Number(this.couponsPay)>0 && Number(this.PointPayMoney)>0){
                if((Number(this.couponsPay)+Number(this.PointPayMoney))>Number(this.unPaidMoney.toFixed(2))){
                    this.$message.error('储值金额和积分总额超出待支付金额');
                    return
                }
            }
            //是否需要验证密码
            if(this.meberInfo.flag==true && this.isCardPayPwd==''){
                this.passwordShow=true
                return
            }
            if(this.PayResultCode==0){
                this.userInfo=this.$auth.getUserInfo(); //获取用户id
                let _order = this.memberorderInfo
                let _meberInfo=''
                /** 预支付总金额 */
                let _counMoney=0
                /**支付方式 */
                let _payment=[]
                let _meber = this.meberInfo
                /**会员信息 */
                _meberInfo ={
                    Member_Sys:7, //会员系统类型 2：正品CRM3.0，4：微生活
                    DynamicType:_meber?.DynamicType, //查询码类型 5i会员类型：1手机会员、2卡会员
                    Card_AutoID:_meber?.Bestech_Card_AutoID, //卡主键
                    Card_No:_meber?.cardno, //卡号
                    Member_Name:_meber?.MemberName, //姓名
                    MemberCard_Kind:_meber?.Bestech_Card_KindName, //会员等级
                    Mobile:_meber?.Mobile,//会员手机号
                    NotJoinPointProgram:this.PointChecked,//不参与线上积分
                    Invoice_Money:0, //本次消费开票金额
                    Invoice_No:'',//发票号码
                }
                //积分支付
                if(this.PointPayMoney>0){
                    _payment.push({
                        Payment_ID:'CardPointPay',  //支付方式ID
                        Payment_Code:this.choicePayType.PAY_CODE, //支付方式编号
                        Payment_Name:this.choicePayType.PAY_NAME, //支付方式名称
                        Payment_Type:this.choicePayType.INTERFACE_TYPE, //支付方式类型
                        Payment_Money:this.PointPayMoney, //支付金额
                        Payment_FactMoney:0, //计营业额
                        Qr_Code:'', //扫码付款的码值
                        Card_No:_meber.Card_No, //卡号
                        CouponInfo:null, //券的详情
                    })
                    _counMoney = _counMoney + Number(this.PointPayMoney)
                }
                //储值
                if(this.couponsPay>0){
                    _payment.push({
                        Payment_ID:'CardMoneyPay',  //支付方式ID
                        Payment_Code:this.choicePayType.PAY_CODE, //支付方式编号
                        Payment_Name:this.choicePayType.PAY_NAME, //支付方式名称
                        Payment_Type:this.choicePayType.INTERFACE_TYPE, //支付方式类型
                        Payment_Money: Number(this.couponsPay), //支付金额
                        Payment_FactMoney:Number(this.couponsPay), //计营业额
                        Qr_Code:'', //扫码付款的码值
                        Card_No:_meber.Card_No, //卡号
                        CouponInfo:null, //券的详情
                    })
                    _counMoney = _counMoney + Number(this.couponsPay)
                }
                /**结合其他付款方式 */
                if(this.paymentHistory){
                    this.paymentHistory.filter(it=>!it.Eat_PayDetailID).forEach(pay=>{
                        _payment.push({
                            Payment_ID:pay.Payment_ID,  //支付方式ID
                            Payment_Code:pay.Payment_Code, //支付方式编号
                            Payment_Name:pay.Payment_Name, //支付方式名称
                            Payment_Type:pay.Payment_Type, //支付方式类型
                            Payment_Money: pay.Payment_Money, //支付金额
                            Payment_FactMoney:pay.Payment_FactMoney, //计营业额
                            Qr_Code:pay.Qr_Code, //扫码付款的码值
                            Card_No:pay.Card_No, //卡号
                            CouponInfo:pay.CouponInfo, //券的详情
                        })
                    })
                }
                if(this.meberInfo.flag){
                    _meberInfo = Object.assign(_meberInfo,{Card_PWD:this.isCardPayPwd})
                }
                let _memberorderInfo = JSON.parse(JSON.stringify(this.orderMenuList))
                let _orderConsumes=this.$global.getFastOrderConsumes(_memberorderInfo);
                let param={
                    User_ID:this.userInfo?.User_ID, //登陆用户ID
                    Operator_Name:this.userInfo?.Login_Name,//操作员
                    Eat_PersonNum:this.headingInfo?.DinersNum,//人数
                    Channel_ID:this.Channellike,//订单渠道ID
                    Room_ID:this.RoomAutoID,//餐厅ID
                    Eat_DeskID:this.headingInfo?.DeskAutoID, //桌台ID
                    Eat_DeskName:this.DeskName, //桌台名称
                    Eat_TakeNo:this.headingInfo?.brandNumber,//牌号
                    Eat_AllRemark:'', //订单全单备注
                    Order_Remark:this.headingInfo.orderRemark,//订单备注
                    Order_BatchNo:newGuid(),//下单批次号，每次提交下单，调用方生成一个唯一批次号，接口判断防止重复下单
                    NotSendToKitPrint:false, //下单不送打厨房
                    ElectronicInvoice_PrintForbidden:this.$global.isNoPrintInvoice,//是否选择禁止打印发票二维码 false: 默认打印发票二维码,true: 不打印发票二维码
                    MantissaAdjustment_Money: Number(Number(this.MantissaMoney).toFixed(2)),//尾数调整金额
                    Member:_meberInfo,//会员信息
                    Payments:_payment, //支付方式列表
                    OrderConsumes:_orderConsumes,//订单消费明细
                }
                if(this.EatAutoIDs){
                    param.Eat_AutoID = this.EatAutoIDs
                    param.Timestamps = this.Timestamps
                }
                console.log(param)
                /**支付预览 */
                const loading = event.loading({
                    text: "支付预览中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.1)",
                });
                this.$httpAES.post("Bestech.CloudPos.SnackPayPreview",param).then((data)=>{
                    loading.close();
                    this.payPreviewData = data
                    this.payPreviewData = data
                    if(data.ResponseBody?.Timestamps){
                        this.ordertimestamps = data.ResponseBody?.Timestamps.toString();
                        this.eatAutoID = data.ResponseBody?.Eat_AutoID
                    }
                    if(data.ResponseHeader.ResultCode!=0){
                        this.$message.error(data.ResponseHeader.ResultDesc);
                        if(data.ResponseHeader.ResultCode==4001){
                            this.PayResultCode=1
                        }
                        if(data.ResponseBody?.Timestamps){
                            this.memberorderInfo.Timestamps = data.ResponseBody.Timestamps.toString()
                        }
                        if(data.ResponseBody?.Eat_AutoID!=undefined && data.ResponseBody?.Eat_AutoID!=null){
                            this.$parentEmit('updateOrder',data.ResponseBody);
                        }
                    }else{
                        this.memberorderInfo.Timestamps = data.ResponseBody.Timestamps.toString()
                        this.memberorderInfo.Mantissa_Money = data.ResponseBody.MantissaAdjustMoney
                        this.tempUserId = data.ResponseBody?.User_ID
                        this.tempOperatorName = data.ResponseBody?.User_Name
                        /**Is_NeedSMSCode：是否需要短信验证码0不需要1需要 */
                        if(data.ResponseBody.Is_NeedSMSCode==1){
                            this.cardCodeShow = true
                            return
                        }
                        /**Is_NeedPassWord：是否需要密码验证0不需要1需要 */
                        if(data.ResponseBody.Is_NeedPassWord==1){
                            this.passwordShow=true
                            return
                        }
                        /**支付提交判断 0不需要 1需要 */
                        if(data.ResponseBody.Is_NeedSubmit==1){
                            this.PaySubmit(data)
                        }else{

                            if(!data.ResponseBody?.IsMultipleCardPay){
                                if(data.ResponseBody?.PrintsInfo){
                                    setTimeout(()=>{
                                        this.$webBrowser.posPrint(data.ResponseBody.PrintsInfo);
                                    },100);
                                }
                                this.$message.success({ message: "支付完成"});
                                this.$emit('paySuccessConfirm');
                            }else{
                                this.$emit('payMultipleConfirm',data.ResponseBody,true);
                            }
                        }
                    }
                }).catch((e)=>{
                    loading.close();
                    this.$alert(e.message, "提示", {confirmButtonText: "确定"});
                })
            }else if(this.PayResultCode==1){
                this.PaySubmit(this.payPreviewData)
            }
        }),
        /**支付提交方法 */
        PaySubmit:submitting(function(event,data){
            if(data.ResponseBody.Is_NeedSubmit==1){
                let param={
                    User_ID:this.userInfo?.User_ID, //登陆用户ID
                    Eat_AutoID: data.ResponseBody?.Eat_AutoID,//结账单ID
                    Member_Type:data.ResponseBody?.Member_Type,  //会员类型
                    MantissaAdjustMoney:data.ResponseBody?.MantissaAdjustMoney,//尾数调整金额
                    Biz_ID:data.ResponseBody?.Biz_ID, //业务交易流
                    Verify_Code:this.verifyCode, //验证码
                    Operator_Name:this.userInfo?.Login_Name, //操作员
                    ElectronicInvoice_PrintForbidden:this.$global.isNoPrintInvoice,//是否选择禁止打印发票二维码 false: 默认打印发票二维码,true: 不打印发票二维码
                    Timestamps:data.ResponseBody.Timestamps.toString(),
                    Payments:data.ResponseBody.Payments
                }
                if(this.tempUserId!='' && this.tempOperatorName!=''){
                    param.User_ID = this.tempUserId
                    param.Operator_Name = this.tempOperatorName
                }
                /**支付提交 */
                const loading = event.loading({
                    text: "支付提交中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.1)",
                });
                this.$httpAES.post("Bestech.CloudPos.SnackPaySubmit",param).then((data)=>{
                    loading.close();
                    if(data.ResponseHeader.ResultCode!=0){
                        //this.memberorderInfo.Timestamps = data.ResponseBody.Timestamps.toString()
                        this.errorTitle = data.ResponseHeader.ResultDesc
                        if(data.ResponseHeader.ResultCode==4001){
                            this.PayResultCode=1
                        }
                        if(data.ResponseHeader.ResultCode==4003){
                            this.PayResultCode=0
                        }
                        this.$message.error(data.ResponseHeader.ResultDesc);
                    }else{
                        this.$message.success({ message: "支付完成"});
                        if(data.ResponseBody?.PrintsInfo){
                            setTimeout(()=>{
                                this.$webBrowser.posPrint(data.ResponseBody.PrintsInfo);
                            },100);
                        }
                        if(data.ResponseBody?.OpenCashBox==true){
                            this.$webBrowser.openCashBoxBnt().then(d=>{
                                if(d?.state!=0){
                                    this.$message.error('钱箱打开失败:'+(d?.message||""));
                                }
                            });
                        }
                        this.$emit('paySuccessConfirm');
                    }
                }).catch((e)=>{
                    loading.close();
                    this.$alert(e.message, "提示", {confirmButtonText: "确定"});
                })
            }
        }),
        
        /**获取星期 */
        setNowTimes(){
            let myDate = new Date()
            let wk = myDate.getDay()
            let weeks = ['7', '1', '2', '3', '4', '5', '6']
            let week = weeks[wk]
            return week;
        },
        /**数据初始化 */
        initializaTion(){
            this.meberInfo=''
            this.payCode=''
            this.couponsPay=0
            this.PointPayMoney=0
            this.PointPayCouponMoney=''
            this.cashCoupon=''
            this.commodityVoucher=''
            this.is_AllowMixUsing=false
            this.is_AllowMixUsingCoupon_Name=''
            this.scanPayCode=''
            this.PayResultCode=0
            this.payPreviewData=''
            this.PointChecked = false
            this.tempUserId='',this.tempOperatorName='';
            this.unPaidMoney = this.snackPaidMoney;
            this.memberorderInfo.forEach(order=>{
                order.isCoupon=false,
                order.CouponNumber=0
            })
        },
        /**会员卡选择返回 */
        selectCardInfo(data){
            this.meberInfo=data;
            if(this.meberInfo.OverDraftLimitedMoney){
                this.meberInfo.Card_Money = Number(this.meberInfo.Card_Money) + Number(this.meberInfo.OverDraftLimitedMoney)
            }
            this.idCode = data.Card_No;
            this.cardMemberShow = false;
            this.cardInfoShow()
            if(this.meberInfo.Is_Have_ParPrice==1){
                this.memberVipMoney(this.meberInfo)
            }
        },
        /**会员卡信息展示 */
        cardInfoShow(){
            let _cashArr = [];  //定义一个数组
            let _commArr=[];
            if(this.meberInfo?.Coupons){
                this.meberInfo.Coupons.forEach(item=>{
                    if(item.Coupon_Kind==1){
                        _cashArr.push(Object.assign(item,{Check:false}))
                        this.cashCoupon=_cashArr;
                    }else{
                        _commArr.push(Object.assign(item,{Check:false}))
                        this.commodityVoucher=_commArr;
                    }
                })
                
            }
            let _unPaidMoney =0,arbal = Number(Math.abs(this.meberInfo.arbal))
            if((this.unPaidMoney.toFixed(2)-Number(this.couponsPay)).toFixed(2)==0){
                _unPaidMoney = this.unPaidMoney.toFixed(2)
            }else{
                _unPaidMoney = (this.unPaidMoney.toFixed(2)-Number(this.couponsPay)).toFixed(2)
            }
            if(this.meberInfo.ReditMoneyRatio==undefined){
                this.PointPay_Scale =  ''
            }else{
                this.PointPay_Scale =  this.meberInfo.ReditMoneyRatio+':1'
            }
        },
        /**验证码返回 */
        cardCodeConfirm(code){
            this.verifyCode=code
            this.cardCodeShow = false
            this.PaySubmit(this.payPreviewData)
        },
        passwordConfirm(pwd){
            this.verifyCode=pwd
            this.passwordShow = false
            this.isCardPayPwd=pwd
            this.confirm()
        },
        swipeConfirm(Cardid){
            this.swipeShow=false
            this.idCode = Cardid
            this.onMemberInfo(true)
        },
        PointPayCouponMoneyInfo(type){
            if(this.meberInfo){
                if(type==0){
                    this.PointPayCouponMoney= Number(this.couponsPay+ Number(this.PointPayMoney))
                }
                if(type==1){
                    this.PointPayCouponMoney= Number(this.couponsPay)+ Number(this.PointPayMoney)
                }
                if(type==2){
                    if(Number(this.couponsPay) + Number(this.PointPayMoney)< this.unPaidMoney){
                        this.PointPayCouponMoney= Number(this.couponsPay) + Number(this.PointPayMoney)
                    }else if(Number(this.couponsPay) + Number(this.PointPayMoney) == this.unPaidMoney){
                        this.PointPayCouponMoney= Number(this.couponsPay) + Number(this.PointPayMoney)
                    }else{
                        this.couponsPay = Number(this.unPaidMoney).compute(this.PointPayMoney,'-') ;
                        this.PointPayCouponMoney = this.unPaidMoney
                    }
                }
            }
            else{
                this.PointPayCouponMoney=0
            }
        },
        /**数字转换 */
        Conversion(num){
            return NumberConversion(num)
        },
        onCouponPayClick(){
            this.PointPayMoney=0;
            setTimeout(()=>{
                this.$refs.couponsPayinput?.select();
            },100)
        },
        onIntegralClick(){
            this.couponsPay=0;
            setTimeout(()=>{
                this.$refs.PointPayinput?.select();
            },100)
        },
    }
}
</script>

<style lang="sass">
@import "./fastWestStoredModel.scss";
</style>